













































import { Component, Vue, Prop } from "vue-property-decorator";
import QuickSnack from "@/components/QuickSnack.vue";
import { executeCommand } from "@/domain/backend/vending";
import { RemoteCommandRequest, VendingConfigOptions } from "@/domain/api";

@Component({
  components: { QuickSnack }
})
export default class VendingExecuteCommand extends Vue {
  @Prop() vendingOptions!: VendingConfigOptions | null;
  @Prop() branchID!: number | null;
  @Prop() tcod!: string | null;
  @Prop() uid!: string | null;

  // COMMANDS
  showCommandDialog = false;
  confirmCommandDialog = false;
  selectedCommand = null;
  otherCommand = null;
  disableConfirmCommand = false;

  get lang() {
    return this.$store.state.lang.data;
  }
  get snackbar() {
    return this.$refs.snackbar as QuickSnack;
  }
  get commands() {
    return [...(this.vendingOptions?.remoteCommandOptions ?? []), { text: "Other", value: "other" }];
  }

  get commandData(): RemoteCommandRequest | null {
    const name = this.selectedCommand == "other" ? this.otherCommand : this.selectedCommand;
    if (!name || !this.tcod || !this.branchID || !this.uid) {
      return null;
    }
    return {
      tcod: this.tcod,
      name,
      user: this.uid,
      branchID: this.branchID
    };
  }

  get disableCommand() {
    if (this.selectedCommand == null) return true;
    if (this.selectedCommand == "other" && this.otherCommand == null) return true;
    return false;
  }

  show() {
    this.showCommandDialog = true;
  }

  closeCommandDialog() {
    this.selectedCommand = null;
    this.otherCommand = null;
    this.showCommandDialog = false;
    this.confirmCommandDialog = false;
    this.disableConfirmCommand = false;
  }

  async executeCommand() {
    try {
      const cmd = this.commandData;
      if (!cmd) throw new Error("Empty command");
      const res = await executeCommand(cmd);
      this.disableConfirmCommand = true;
      if (res.saved === true) {
        this.snackbar.show(this.lang.executeCommandSuccess, "success");
        this.closeCommandDialog();
      } else {
        this.snackbar.show(this.lang.executeCommandFailed + " " + res.message, "error");
      }
    } catch (err) {
      this.snackbar.show(this.lang.executeCommandFailed + (err as Error).message, "error");
    } finally {
      this.disableConfirmCommand = false;
    }
  }
}
